import varAxios from "../../../Comman/axios";

import { syncUserUrl,insertAlarmDataUrl, abortMissionAlarmUrl, syncSettingUrl,
    syncFirstResponderKitLocationUrl, GetAllContactSettingUrl, autoSynchronizationUserTimeUrl} from "../../../Comman/apiEndPoints"

export const SYNC_USER_REQUEST = "(sync) SYNC USER REQUEST";
export const SYNC_USER_SUCCESS = "(sync) SYNC USER SUCCESS";
export const SYNC_USER_ERROR = "(sync) SYNC USER ERROR";

export const SYNC_SETTING_REQUEST = "(sync) SYNC_SETTING_REQUEST";
export const SYNC_SETTING_SUCCESS = "(sync) SYNC_SETTING_SUCCESS";

export const SYNC_LOCATION_REQUEST = "SYNC_LOCATION_REQUEST";
export const SYNC_LOCATION_SUCCESS = "SYNC_LOCATION_SUCCESS";

export const INSERT_ALARM_JSON_REQUEST = "(insert) INSERT ALARM JSON REQUEST";
export const INSERT_ALARM_JSON_SUCCESS = "(insert) INSERT ALARM JSON SUCCESS";
export const INSERT_ALARM_JSON_ERROR = "(insert) INSERT ALARM JSON ERROR";
export const Abort_Mission_Success = "Abort_Mission_Success";
export const Abort_Mission_Request = "Abort_Mission_Request";

export const FETCH_AUTO_SYNC_USER_TIME_DATA = "FETCH_AUTO_SYNC_USER_TIME_DATA";
export const SYNC_USER_TIME_REQUEST = "SYNC_USER_TIME_REQUEST";

export function syncUser(dispatch) {

    return (dispatch) => {
        dispatch(syncUserRequest(true));

        return varAxios.post(syncUserUrl,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                console.log(response)
                dispatch(
                    syncUserSuccess(false,
                     response.data.errorMessage, 
                     response.data.statusCode, 
                     response.data.errorMessage
                    )
                );
            })
            .catch((error) => {
                // dispatch(
                //     addDeviceDetailSuccess(false, formData, error.response.data.errorMessage, error.response.data.statusCode, error.response.data.errorMessage)
                // );
            })
    }
}
export function syncSetting(dispatch) {
    return (dispatch) => {
        dispatch(syncSettingRequest(true));
        return varAxios.get(syncSettingUrl)
            .then((response) => {
                console.log(response)
                dispatch(
                    syncSettingSuccess(false,
                     response.data.Message, 
                     response.data.statusCode, 
                     response.data.errorCode
                    )
                );
            })
            .catch((error) => {
                // dispatch(
                //     addDeviceDetailSuccess(false, formData, error.response.data.errorMessage, error.response.data.statusCode, error.response.data.errorMessage)
                // );
            })
    }
}
export function syncSettingRequest(isLoading) {
    return {
        type: SYNC_SETTING_REQUEST,
        isLoading
    }
}
export function syncSettingSuccess(isLoading, messageLabel, statusCode, errorCode) {
    return {
        type: SYNC_SETTING_SUCCESS,
        isLoading,
        messageLabel,
        statusCode,
        errorCode
    }
}
export function syncUserRequest(isLoading) {
    return {
        type: SYNC_USER_REQUEST,
        isLoading
    }
}
export function syncUserSuccess(isLoading, messageLabel, errorNumber, errorMessage) {
    return {
        type: SYNC_USER_SUCCESS,
        isLoading,
        messageLabel,
        errorNumber,
        errorMessage

    }
}

export function insertAlarmJSON(data,dispatch) {

    return (dispatch) => {
        dispatch(insertAlarmJSONRequest(true));

        return varAxios.post(insertAlarmDataUrl,data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                console.log(response)
                dispatch(
                    insertAlarmJSONSuccess(false, 
                        response.data.Message, 
                        response.data.statusCode, 
                        response.data.Message
                        )
                );
            })
            .catch((error) => {
                // dispatch(
                //     addDeviceDetailSuccess(false, formData, error.response.data.errorMessage, error.response.data.statusCode, error.response.data.errorMessage)
                // );
            })
    }
}

export function insertAlarmJSONRequest(isLoading) {
    return {
        type: INSERT_ALARM_JSON_REQUEST,
        isLoading
    }
}

export function insertAlarmJSONSuccess(isLoading, messageLabel, statusCode, errorMessage) {
    
    return {
        type:INSERT_ALARM_JSON_SUCCESS,
        isLoading,
        messageLabel,
        statusCode,
        errorMessage

    }
}
export function abortMissionAlarm(id) {
    let data = {
        MissionId : id
    }
    return (dispatch) => {
        dispatch(abortMissionRequest(true));
        return varAxios.post(abortMissionAlarmUrl, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                if(response.data.statusCode == 200){
                    dispatch(
                        abortMissionSuccess(false,response.data.statusCode, response.data.errorCode,response.data.Message,response.data.Message)
                  );
                }
            })
            .catch((error) => {
                dispatch(
                    abortMissionSuccess(false,error.response.data.statusCode, error.response.data.errorCode,error.response.data.Message,error.response.data.Message)
              );
            })
    }
}
export function abortMissionSuccess(isLoading,statusCode,errorCode,message,messageLabel) {
    return {
        type : Abort_Mission_Success,
        isLoading,
        statusCode,
        errorCode,
        message,
        messageLabel
    }    
}
export function abortMissionRequest(isLoading) {
    return {
        type : Abort_Mission_Request,
        isLoading
    }
}
export function syncKitLocationOnDispatcher(dispatch) {
    return (dispatch) => {
        dispatch(syncLocationRequest(true));
        return varAxios.get(syncFirstResponderKitLocationUrl)
            .then((response) => {
                dispatch(
                    syncLocationSuccess(false,
                     response.data.errorMessage, 
                     response.data.statusCode, 
                     response.data.errorCode
                    )
                );
            })
            .catch((error) => {
                
            })
    }
}
export function syncLocationRequest(isLoading) {
    return {
        type: SYNC_LOCATION_REQUEST,
        isLoading
    }
}
export function syncLocationSuccess(isLoading, messageLabel, statusCode, errorCode) {
    return {
        type: SYNC_LOCATION_SUCCESS,
        isLoading,
        messageLabel,
        statusCode,
        errorCode
    }
}

export function getAutoSynchronizationUserTime() {
    return(dispatch) =>{
        dispatch(syncUserTimeRequest(true));
       return varAxios.get(GetAllContactSettingUrl)
       .then(response => {
           if(response.data.statusCode == 200){
               response.data.GlobalSettings.forEach(item => {
                   if(item.SettingName == "AutoSynchronizationUserTime"){
                    dispatch(
                        fetchAutoSynchronizationUserTimeData(false,item.SettingValue,'', response.data.statusCode)
                        );
                    }
               })
           }
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAutoSynchronizationUserTimeData(isLoading, value, message, statusCode) {
    return {
      type : FETCH_AUTO_SYNC_USER_TIME_DATA,
      isLoading,
      value,
      message,
      statusCode
    }
}
export function updateAutoSynchronizationUserTimeFunc(value) {
    return (dispatch) => {
        dispatch(syncUserTimeRequest(true));
        return varAxios.post(autoSynchronizationUserTimeUrl, value,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              if(response.data.statusCode == 200){
                dispatch(
                    fetchAutoSynchronizationUserTimeData(false,response.data.Value,response.data.Message, response.data.statusCode)
                );
              }
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function syncUserTimeRequest(isLoading) {
    return {
        type: SYNC_USER_TIME_REQUEST,
        isLoading
    }
}